import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { APIProvider } from '@vis.gl/react-google-maps';
import { useSwal } from '../../hooks/use-swal';
import { useStorage } from '../../hooks/use-storage';
import { AddressComplementModalBody } from '../../components/location/address-complement-modal-body';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useAddressComplementModal() {
  const storage = useStorage();
  const analytics = useAnalytics();
  const { analyticsPageView } = analytics;
  const { config, menuInfo } = storage;
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  const complementRef = useRef();

  const didOpen = () => {
    analyticsPageView('Address Complement');
  };

  async function clear() {
    complementRef.current = null;
  }

  async function show({ placeDetails, baseLocation, noStreetNumber }) {
    const result = await swal.fire({
      html: (
        <APIProvider
          apiKey={config?.maps?.browser?.api_key}
          language={menuInfo?.i18n?.default_language?.tag}
        >
          <AddressComplementModalBody
            placeDetails={placeDetails}
            baseLocation={baseLocation}
            noStreetNumber={noStreetNumber}
            complement={complementRef.current}
            onComplementChange={(value) => {
              swal.resetValidationMessage();
              complementRef.current = value;
            }}
            config={config}
          />
        </APIProvider>
      ),
      // timer: layoutDefaults.modalTimer,
      didOpen,
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: t('continue'),
      cancelButtonText: t('back'),
    });

    if (result.isConfirmed) {
      result.complement = complementRef.current;
    }

    result.wasComplementBackButtonClicked = result.isDismissed;
    return result;
  }

  return {
    clearAddressComplementModal: clear,
    showAddressComplementModal: show,
  };
}

export { useAddressComplementModal };
